import styled from 'styled-components';

export const NewsFeedItemLink = styled.a`
  display: flex;
  align-items: center;
  padding: 12px;
  text-decoration: none;

  &:hover {
    text-decoration: none;
    background-color: ${({ theme }) => theme.news.palette.bg_hover_normal_pc};
  }
`;
